import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum ReservationTaskTemplateConditionTypeId {
  SERVICE = 'service',
  GUESTS_COUNT = 'guests_count',
  STAY_LENGTH = 'stay_length',
  ROOM_TYPE = 'room_type',
  PACKAGE = 'package',
  NUMBER_OF_STAYS = 'number_of_stays',
  GUEST_TAG = 'guest_tag',
}

export class ReservationTaskTemplateConditionType extends Codebook<ReservationTaskTemplateConditionTypeId> {
  static readonly SERVICE = new ReservationTaskTemplateConditionType(
    ReservationTaskTemplateConditionTypeId.SERVICE,
    () => $t('reservationTaskTemplateConditionType.service'),
  )

  static readonly GUESTS_COUNT = new ReservationTaskTemplateConditionType(
    ReservationTaskTemplateConditionTypeId.GUESTS_COUNT,
    () => $t('reservationTaskTemplateConditionType.guestsCount'),
  )

  static readonly STAY_LENGTH = new ReservationTaskTemplateConditionType(
    ReservationTaskTemplateConditionTypeId.STAY_LENGTH,
    () => $t('reservationTaskTemplateConditionType.stayLength'),
  )

  static readonly ROOM_TYPE = new ReservationTaskTemplateConditionType(
    ReservationTaskTemplateConditionTypeId.ROOM_TYPE,
    () => $t('reservationTaskTemplateConditionType.roomType'),
  )

  static readonly PACKAGE = new ReservationTaskTemplateConditionType(
    ReservationTaskTemplateConditionTypeId.PACKAGE,
    () => $t('reservationTaskTemplateConditionType.package'),
  )

  static readonly NUMBER_OF_STAYS = new ReservationTaskTemplateConditionType(
    ReservationTaskTemplateConditionTypeId.NUMBER_OF_STAYS,
    () => $t('reservationTaskTemplateConditionType.numberOfStays'),
  )

  static readonly GUEST_TAG = new ReservationTaskTemplateConditionType(
    ReservationTaskTemplateConditionTypeId.GUEST_TAG,
    () => $t('reservationTaskTemplateConditionType.guestTag'),
  )

  private constructor(
    id: ReservationTaskTemplateConditionTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
